var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FctAddress } from '../../../Fct/generics';
import cTokens from '../../../Fct/tokens/cTokens.json';
export var compoundTokens = cTokens.map(function (token) { return (__assign(__assign({}, token), { value: token.address })); });
export var isNative = function (address, chainId) {
    if (chainId === '1')
        return address.toLowerCase() === '0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5'.toLowerCase();
    return address.toLowerCase() === '0x20572e4c090f15667cF7378e16FaD2eA0e2f3EfF'.toLowerCase();
};
export var getCompoundPluginAddressesInput = function (_a) {
    var chainId = _a.chainId;
    var tokens = {};
    var labels = [];
    var chainTokens = compoundTokens.filter(function (token) { return token.chainId === Number(chainId); });
    chainTokens.forEach(function (token, index) {
        var address = index > 0
            ? new FctAddress({ required: false, hidden: true, destination: 'erc20', options: chainTokens })
            : new FctAddress({ destination: 'erc20', options: chainTokens });
        tokens["address".concat(index + 1)] = address;
        labels.push("address".concat(index + 1));
    });
    return { tokens: tokens, labels: labels };
};
